module.exports = "<section>\n    <app-slide-panel></app-slide-panel>\n</section>\n"